import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取站内通知列表(商户端通知列表)
 * @param params
 */
export const getInstationMsgListApi = (params: object = {}) => $http.get('/admin/shops/getInstationMsgList', params)

/**
 * 获取取站内通知角标数据
 * @param id
 */
 export const getInstationMsgWarnApi = (id: number) => $http.get('/admin/shops/getInstationMsgWarn', { id, notShowLoading: true })

/**
 * 平台教程-已读回调
 * */
export const saveTrainingViewLogApi = (course_id: any) => $http.post('/admin/shops/do_course_rules', { course_id })

// 获取群通知列表
export const getGroupMsgList = (params: object = {}) => $http.get('/admin/brands/batchSendMsgsList', params)

// 获取群通知列表-查看内容、商家详情
export const batchSendMsgsInfo = (params: object = {}) => $http.get('/admin/brands/batchSendMsgsInfo', params)

// 获取平台教程列表（商户）
export const getTrainingListApi = (params: object) => $http.post('/admin/shops/getCourseList', params)
